import { WestRounded } from '@mui/icons-material';

import { List, Button, Stack, Typography } from '@mui/material';
import { PromoCard } from '../promo-card';
import { SubMenuItem } from './nav-item-child';
import { NavEntity } from 'types/header';

export const NavItem = ({
  item,
  onClickBack,
  closeMenu,
}: {
  item: NavEntity;
  onClickBack: () => void;
  closeMenu: () => void;
}) => {
  return (
    <Stack sx={{ width: '100%' }}>
      <Stack gap={4} mb={2}>
        <Button
          disableRipple
          disableTouchRipple
          disableFocusRipple
          sx={{ textTransform: 'none', justifyContent: 'flex-start' }}
          onClick={onClickBack}
          startIcon={<WestRounded />}
        >
          Indietro
        </Button>
        {/* <Typography variant="editorialBig" fontSize={52}> */}
        <Typography variant="body1" fontSize={52}>
          {item.title}
        </Typography>
      </Stack>
      <List>
        {item.dropdownItems?.map((dropdownItem, index) => (
          <SubMenuItem
            key={dropdownItem.title}
            item={dropdownItem}
            showBorder={index < (item.dropdownItems?.length ?? 0) - 1}
            closeMenu={closeMenu}
          />
        ))}
      </List>
      {item.cardEvent && <PromoCard cardEvent={item.cardEvent} />}
    </Stack>
  );
};
